// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

// shared components
import { ServiceGuard } from '@/components/access-control/ServiceGuard';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/deepdive',
)({
  component: () => (
    <ServiceGuard
      serviceNames={['EnergyXplorer']}
      fallback={<Navigate to="/$accountId/missing-service" />}
    >
      <Suspense>
        <Outlet />
      </Suspense>
    </ServiceGuard>
  ),
  staticData: { crumb: 'glossary:deepdive' },
});
